import Vue from 'vue'
import router from './router'
import App from './App.vue'
import HomePage from './HomePage.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css';
import VueRouter from "vue-router";
import * as echarts from "echarts";
import './theme.scss';
import { axiosInit } from './config/axiosInit'
Vue.prototype.$echarts = echarts;
Vue.use(Avue);
Vue.use(HomePage);
Vue.use(ElementUI);
Vue.use(VueRouter);

Vue.config.productionTip = false
new Vue({
  el: "#app",
  router, 
  template: "<App/>",
  components: { App }
}).$mount('#app')
